import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile, ChangeLight } from "../../request";
@Component({
    components: {}
})
export class takeMixin extends Vue {
    @Prop()
    data: any;
    @Prop()
    ifShow: any;
    @Watch("ifShow", { immediate: true })
    async ifShowChange() {
        this.visible = this.ifShow;
        if (this.ifShow) {
            this.imgs = [];
            this.imgData = [];
            this.filming = false;
            this.readying = false;
            this.photoData = ''
            this.devices = [];
            this.cDevice = {};
            // 关闭紫光
            console.log("打开弹框后：紫外光-OFF");
            const res = await window.electronMyAPI.changeLight("紫外光-OFF");
            if (res) {
                this.$store.commit("updateIfShowZiwai", false);
                // 打开均匀光
                console.log("打开弹框后：白光-ON-100");
                window.electronMyAPI.changeLight("白光-ON-100");
            }
            this.getCameraDevices();
        } else {
        }
    }
    visible: any = false;
    stream: any = "";
    photoData: any = "";
    imgData: any = [];
    imgs: any = [];
    devices: any = [];
    cDevice: any = {};
    filming: any = false;
    times: any = 0; // 当前查找次数
    maxTimes: any = 4; // 最大重复次数
    readying: any = false;
    async cancel() {
        this.$emit("cancel");
        if (this.stream) {
            this.stream.getTracks().forEach((track: any) => track.stop());
        }
        this.resetCamera();
        this.imgs = [];
        this.imgData = [];
        this.devices = [];
        this.cDevice = {};
        this.filming = false;
        // 关闭均匀光
        console.log("关闭白光");
        window.electronMyAPI.changeLight("白光-OFF");
    }
    preview(url: any) {
        window.open(url);
    }
    resetPhoto() {
        this.imgs = [];
        this.imgData = [];
        this.resetCamera();
        this.startCamera();
    }
    selectDevice(item: any) {
        this.cDevice = item;
        this.startCamera();
    }
    base64ToBlob(base64Data: string, contentType = ""): Blob {
        contentType = contentType || base64Data.split(",")[0].split(":")[1];
        const sliceSize = 1024;
        const byteCharacters = atob(base64Data.split(",")[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    async startCamera() {
        this.readying = true;
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: { exact: this.cDevice.deviceId },
                    width: { exact: 3840 },
                    height: { exact: 2880 },
                    // height: { exact: 3040 },
                },
            });
            (this.$refs.video as any).srcObject = this.stream;
            (this.$refs.video2 as any).srcObject = this.stream;
            this.readying = false;
        } catch (err) {
            console.error("Error accessing the camera:", err);
            this.readying = false;
            this.$message.error("设备连接失败，请检查设备连接状态");
            this.cDevice = {};
        }
    }
    changeLight() {
        return new Promise(async (resolve, reject) => {
            if (this.imgData.length == 0) {
                const res = await window.electronMyAPI.changeLight("白光-ON-100");
                // 延时1秒调光
                if (res) {
                    resolve(true);
                }
            } else if (this.imgData.length == 1) {
                const res = await window.electronMyAPI.changeLight("白光-OFF");
                if (res) {
                    const res2 = await window.electronMyAPI.changeLight("绿光-ON");
                    if (res2) {
                        resolve(true);
                    }
                }
            } else if (this.imgData.length == 2) {
                const res = await window.electronMyAPI.changeLight("绿光-OFF");
                if (res) {
                    const res2 = await window.electronMyAPI.changeLight("平行光-ON");
                    if (res2) {
                        resolve(true);
                    }
                }
            }
        });
    }
    async takePhoto () {
        return new Promise((resolve, reject) => {
            if (this.stream) {
                if (this.data.camera_rotation_angle == '90' || this.data.support_take_photos || this.data.support_USB) {
                    const video = this.$refs.video as HTMLVideoElement;
                    // const canvas = this.$refs.canvas as HTMLCanvasElement;
                    const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

                    // 设置 Canvas 尺寸为视频帧旋转后的尺寸
                    canvas.width = video.videoHeight; // 旋转后的宽度是原始高度
                    canvas.height = video.videoWidth; // 旋转后的高度是原始宽度
                    const context: any = canvas.getContext("2d");

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 保存当前状态
                    context.save();

                    // 转换原点至画布中心
                    context.translate(canvas.width / 2, canvas.height / 2);

                    // 旋转画布90度（顺时针）
                    context.rotate(Math.PI / 2);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        0,
                        0, // 从视频左上角开始，绘制整个视频帧
                        video.videoWidth,
                        video.videoHeight, // 视频帧的原始宽度和高度
                        -video.videoWidth / 2,
                        -video.videoHeight / 2, // 从画布中心点的x轴负方向开始（旋转后的y轴）
                        video.videoWidth,
                        video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    // this.photoData = canvas.toDataURL("image/png");
                    // this.imgData.push(this.photoData);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("Failed to generate image blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                } else if (this.data.camera_rotation_angle == '180') {
                    const video = this.$refs.video as HTMLVideoElement;
                    const canvas = document.createElement("canvas");

                    // 正确设置 Canvas 尺寸为视频帧的尺寸
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;

                    const context = canvas.getContext("2d");

                    if (!context) {
                        reject(new Error("无法获取 canvas 上下文"));
                        return;
                    }

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 保存当前状态
                    context.save();

                    // 转换原点至画布中心
                    context.translate(canvas.width / 2, canvas.height / 2);

                    // 旋转画布 180 度（顺时针）
                    context.rotate(Math.PI);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        -video.videoWidth / 2,
                        -video.videoHeight / 2,
                        video.videoWidth,
                        video.videoHeight
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("无法生成图像 Blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                } else if (this.data.camera_rotation_angle == '270') {
                    const video = this.$refs.video as HTMLVideoElement;
                    // const canvas = this.$refs.canvas as HTMLCanvasElement;
                    const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

                    // 设置 Canvas 尺寸为视频帧旋转后的尺寸
                    canvas.width = video.videoHeight; // 旋转后的宽度是原始高度
                    canvas.height = video.videoWidth; // 旋转后的高度是原始宽度
                    const context: any = canvas.getContext("2d");

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 保存当前状态
                    context.save();

                    // 转换原点至画布中心
                    context.translate(canvas.width / 2, canvas.height / 2);

                    // 旋转画布90度（逆时针）
                    context.rotate(-Math.PI / 2);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        0,
                        0, // 从视频左上角开始，绘制整个视频帧
                        video.videoWidth,
                        video.videoHeight, // 视频帧的原始宽度和高度
                        -video.videoWidth / 2,
                        -video.videoHeight / 2, // 从画布中心点的x轴负方向开始（旋转后的y轴）
                        video.videoWidth,
                        video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    // this.photoData = canvas.toDataURL("image/png");
                    // this.imgData.push(this.photoData);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("Failed to generate image blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                } else {
                    const video = this.$refs.video as HTMLVideoElement;
                    // const canvas = this.$refs.canvas as HTMLCanvasElement;
                    const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

                    // 设置 Canvas 尺寸为视频帧旋转后的尺寸
                    canvas.width = video.videoWidth; // 旋转后的宽度是原始高度
                    canvas.height = video.videoHeight; // 旋转后的高度是原始宽度
                    const context: any = canvas.getContext("2d");

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        0,
                        0, // 从视频左上角开始，绘制整个视频帧
                        video.videoWidth,
                        video.videoHeight, // 视频帧的原始宽度和高度
                        0,
                        0,
                        video.videoWidth,
                        video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    // this.photoData = canvas.toDataURL("image/png");
                    // this.imgData.push(this.photoData);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("Failed to generate image blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                }

            }
        });
    }
    resetCamera() {
        console.log("重新拍摄");
        // 重置photoData和Canvas
        this.stream = "";
        this.photoData = "";
        const canvas = this.$refs.canvas as HTMLCanvasElement;

        if (canvas) {
            const context: any = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.height);
        }
    }
    sure() {
        window.electronMyAPI.changeLight("白光-OFF")
        this.$emit("sure", this.imgs);
    }
    upload(d: any) {
        return new Promise((resolve, reject) => {
            // 将 photoData 转换为 Blob 对象
            const blob = this.base64ToBlob(d);
            // 获取当前时间的时间戳（毫秒级）
            const timestamp = Date.now();
            const filename = `${timestamp}.jpg`;
            // FormData 对象
            const form = new FormData();
            // Blob 对象作为文件添加到表单中
            form.append("file", blob, filename); // 可以指定文件名

            UploadFile(this, form)
                .then((res: any) => {
                    this.imgs.push(res.data);
                    resolve(res.data);
                })
                .catch(() => {
                    reject();
                });
        });
    }
    async getCameraDevices() {
        this.times = 1;
        console.log("查找次数：" + this.times);
        const loading = this.$loading({
            lock: true,
            text: "查找设备中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                loading.close();
                this.$message.error("设备枚举功能不可用");
                return;
            }

            const devices = await navigator.mediaDevices.enumerateDevices();
            console.log("设备列表", devices);
            this.devices = devices.filter((device) => device.kind === "videoinput");
            loading.close();
            
            if (this.devices.length === 0) {
                this.$message.error("未找到可用设备");
                return;
            }
            
            // 选择第一个设备并启动摄像头
            console.log("设备列表", this.devices);
            this.cDevice = this.devices[0];
            await this.startCamera();
        } catch (err) {
            console.error("Error accessing the camera:", err);
            loading.close();
            this.$message.error("设备查找失败");
        }
    }
}